import React from 'react';
import Moment from 'react-moment';

import moment from 'moment';
import 'moment/locale/es';
import 'moment-timezone';
import { ServicioObjetos } from './ServicioObjetos';

Moment.globalMoment = moment;
Moment.globalLocale = 'es';
Moment.globalTimezone = 'America/Mexico_City';

const formatoModena = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
});

export const ServicioFormatos = {

  formatearModena(valor) {
    return formatoModena.format(valor);
  },

  formatearFecha(valor) {
    if (ServicioObjetos.esObjetoVacio(valor)) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="YYYY-MM-DD HH:mm:ss"></Moment>

    }
  },

  formatearFechaString(valor) {
    if (ServicioObjetos.esObjetoVacio(valor)) {
      return null;
    } else {
      let fecha = moment(valor).format('YYYY-MM-DD HH:mm:ss');
      return fecha;
    }
  },
  formatearFechaPago(valor) {
    if (ServicioObjetos.esObjetoVacio(valor)) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="YYYY-MM-DD"></Moment>

    }
  }
}